import { render, staticRenderFns } from "./DialogOrderList.vue?vue&type=template&id=0c18f9f5"
import script from "./DialogOrderList.vue?vue&type=script&lang=js"
export * from "./DialogOrderList.vue?vue&type=script&lang=js"
import style0 from "./DialogOrderList.vue?vue&type=style&index=0&id=0c18f9f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports